const isMacOS = window.navigator.platform.includes('Mac')

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const zIndex = {
  HEADER: 1,
  EXTENSION_LOADING: 13,
}

export const mapShortcutKeys: Record<string, string> = {
  alt: isMacOS ? '⌥' : 'ALT',
  ctrl: isMacOS ? '⌘' : 'CTRL',
  left: '←',
  right: '→',
  enter: '↩',
}

export const DEFAULT_MEETING_TYPE_NAME = 'Meeting Type'

export const DEFAULT_AVAILABILITY_SCHEDULE_NAME = 'Availability Schedule'

export const DATA_ASSIST_PANEL_WIDTH = '432px'

export const BUFFER_EVENT_CLASS_NAME = 'chili-buffer-event'

export const DEFAULT_DEBOUNCE_TIMER = 1500

export const INTERVAL_DURATION_DAYS = 7

export const KOSMOTIME_PANEL_WIDTH = 505

export const DEFAULT_CONTAINER_LEFT_POSITION = 10

export const DEFAULT_TASK_DURATION_SECONDS = 900
